import React from 'react';
import PropTypes from 'prop-types';
import {ListItem} from './ListItem';
import {MCStateContext} from '../../..';
import {useTranslation} from 'react-i18next';

import './style.scss';

const ITEM_TEXT = {
  TUBE_BALANCED: 'TubeBalanced',
  LID_CLOSED: 'LidClosed',
};

export function WarningBlock(props) {
  const {balanced, isLidOpen} = React.useContext(MCStateContext);

  const {t} = useTranslation();

  return (
    <div className='mc_warningBlock'>
      <ListItem text={ITEM_TEXT.TUBE_BALANCED} isSuccess={balanced} />
      <ListItem text={ITEM_TEXT.LID_CLOSED} isSuccess={!isLidOpen} />
    </div>
  );
}

WarningBlock.propTypes = {};

WarningBlock.defaultProps = {};
